import React from "react";
import { Card, CardBody } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./product-card.css";

const ProductCard = ({ product, link, stateData }) => {
  const { id } = useParams();
  const { masp, tensp, hinhanh, mota, khoiluong, khoiluongKhac } = product;
  const { t, i18n } = useTranslation(); // Thêm useTranslation

  // Xử lý hiển thị khối lượng
  const displayWeight = () => {
    if (!khoiluongKhac || khoiluongKhac.length === 0) {
      return khoiluong ? khoiluong : "Không có thông tin khối lượng";
    }
    return khoiluongKhac.join(" | ");
  };

  // Danh sách từ khóa để ngắt dòng (các loại hạt)
  const breakKeywords = [
    "hạt điều",
    "hạt mắc ca",
    "hạnh nhân và nho khô",
    "cà phê",
    "sầu riêng",
    "bạc hà",
    "không đường 68%",
    "cao cấp (CW999)",
    "nhân dừa",
    "nhân xoài",
    "hạt hạnh nhân",
    "nhân nho khô",
    "Tiền Giang 71%",
    "Bến Tre 79%",
    "Vũng Tàu 77%",
    "Đồng Nai 73%",
    "Lâm Đồng 75%",
    "Đắk Lắk 71%",
    "cao cấp (CD111)",
    "cao cấp (CW999-B)",
    "cao cấp (LD004)",
    "cao cấp (CD111-B)",
    "(LD001-C)",
    "(CD333-CD888)",
    "(CW005)",
    "(FD002)",
    "hạt sen",
    "cao cấp (FD003)",
    "cao cấp (FW003)",
    "dark Chocolate",
  ];

  // Hàm định dạng tên sản phẩm, ngắt dòng khi gặp từ khóa

  const formatProductName = () => {
    let parts = [t(`${masp}.ten_san_pham`)];

    breakKeywords.forEach((keyword) => {
      parts = parts.flatMap((part) =>
        part.includes(keyword)
          ? part
              .split(keyword)
              .map((p) => p.trim())
              .concat(keyword)
          : [part]
      );
    });
    return parts.filter((part) => part.length > 0);
  };

  const formattedParts = formatProductName();

  return (
    <div className="product__card">
      <Card>
        <div className="product__img">
          <Link to={link} state={stateData}>
            <img
              src={hinhanh}
              alt={tensp}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </Link>
        </div>

        <CardBody className="card__body">
          <h5 className="product__title">
            <Link to={link} state={stateData}>
              {formattedParts.map((part, index) => (
                <span key={index}>
                  {part}
                  {index < formattedParts.length - 1 && (
                    <>
                      <br />
                    </>
                  )}
                </span>
              ))}
            </Link>
          </h5>
          {/* <p className="product__desc">{mota}</p> */}
          <p className="product__weight">{displayWeight()}</p>
          <div className="card__bottom d-flex align-items-center justify-content-between mt-3">
            <Link to={`/lien-he`} className="btn booking__btn">
              <button className="btn contact__btn">
                {t("prod_card_contact")}
              </button>
            </Link>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default ProductCard;
